import { SxProps } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { pureWhiteColor, slateGrey800 } from '00.app/theme';

export const SeparatorQCFieldBoxStyle: SxProps<Theme> = (theme) => ({
  mt: 2,
  mb: 2,
  p: 1,
  minHeight: '1vh',
  backgroundColor: theme.palette.separator.main,
  color: theme.palette.text.primary,
  borderRadius: '5px',
  width: '100%',
});

export const SeparatorQCFieldTypoStyle: SxProps = {
  fontWeight: 600,
};
